import React from "react";
import Box from "@mui/material/Box";
import { getContrastRatio, useTheme } from "@mui/material";
import { decodeColor } from "../../../helpers/color";

const SimpleBox = ({
    children,
    height = undefined,
    padding = 0,
    backgroundColor = undefined,
    fontColor = undefined,
    fontSize = undefined,
    flexDirection = "row",
    justifyContent = "space-between",
    flexWrap = "nowrap",
    fullWidth = false,
    alignItems="center",
    gap = 0,
    ml = 0,
    mr = 0,
    mt = 0,
    mb = 0,
    pt = undefined,
    pb = undefined,
    pl = undefined,
    pr = undefined,
    overflow = undefined,
    borderRadius = undefined,
    borderRadiusTop = undefined,
    borderRadiusBottom = undefined,
    border = undefined,
    borderTop = undefined,
    borderBottom = undefined,
    boxShadow = undefined,
    transition = undefined,
    gradient = undefined,
}) => {
    const theme = useTheme();
    const bgcolor = decodeColor(backgroundColor, theme);
    const color = decodeColor(fontColor, theme, bgcolor);
    return (
        <Box
            overflow={overflow}
            gap={theme.spacing(gap)}
            bgcolor={bgcolor}
            color={color}
            display="flex"
            height={height}
            alignItems={alignItems}
            padding={theme.spacing(padding)}
            fontSize={fontSize}
            flexDirection={flexDirection}
            justifyContent={justifyContent}
            ml={theme.spacing(ml)}
            mr={theme.spacing(mr)}
            mt={theme.spacing(mt)}
            mb={typeof mb === "number" ? theme.spacing(mb) : mb}
            pt={Boolean(pt) ? theme.spacing(pt) : undefined}
            pb={Boolean(pb) ? theme.spacing(pb) : undefined}
            pl={Boolean(pl) ? theme.spacing(pl) : undefined}
            pr={Boolean(pr) ? theme.spacing(pr) : undefined}
            flexWrap={flexWrap}
            width={fullWidth ? "100%" : undefined}
            sx={{
                background: Boolean(gradient) ? gradient : undefined,
                borderRadius: Boolean(borderRadius) ? theme.spacing(borderRadius) : undefined,
                borderTopRightRadius: Boolean(borderRadiusTop) ? theme.spacing(borderRadiusTop) : undefined,
                borderTopLeftRadius: Boolean(borderRadiusTop) ? theme.spacing(borderRadiusTop) : undefined,
                borderBottomRightRadius: Boolean(borderRadiusBottom) ? theme.spacing(borderRadiusBottom) : undefined,
                borderBottomLeftRadius: Boolean(borderRadiusBottom) ? theme.spacing(borderRadiusBottom) : undefined,
                border: border,
                borderTop: borderTop,
                borderBottom: borderBottom,
                boxShadow: Boolean(boxShadow) ?  theme.shadows[boxShadow] : undefined,
                transition: transition,
            }}
        >
            {children}
        </Box>
    );
}

export default SimpleBox;
